import { useState } from "react";
import { Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { Sidebar } from "./Sidebar";
import { MobileNav } from "./MobileNav";
import { TopBar } from "./TopBar";

const SIDEBAR_KEY = "sidebar_open";

export const AppLayout = () => {
  const [sidebarOpen, setSidebarOpenState] = useState(() => localStorage.getItem(SIDEBAR_KEY) !== "0");
  const isMobile = useIsMobile();

  const setSidebarOpen = (open: boolean) => {
    localStorage.setItem(SIDEBAR_KEY, open ? "1" : "0");
    setSidebarOpenState(open);
  };

  return (
    <div className="min-h-screen bg-sidebar">
      {!isMobile && <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />}

      <div
        className={cn(
          "min-h-screen bg-canvas transition-[margin] duration-300",
          !isMobile && "md:rounded-l-[28px]",
          isMobile ? "ml-0" : sidebarOpen ? "ml-[264px]" : "ml-[84px]"
        )}
      >
        <div className="sticky top-0 z-[90] bg-canvas/85 backdrop-blur-md px-4 sm:px-6 lg:px-8 md:rounded-tl-[28px]">
          <TopBar leading={isMobile ? <MobileNav /> : undefined} />
        </div>
        <main className="px-4 sm:px-6 lg:px-8 pb-10 pt-2">
          <div className="mx-auto max-w-[1600px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
